import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Download, Loader2, Printer } from "lucide-react";
import { api, API } from "../lib/api";
import { Certificate } from "../components/Certificate";

export default function CertificatePage() {
  const { registryId } = useParams();
  const [record, setRecord] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/registries/${registryId}`).then(({ data }) => setRecord(data)).catch(() => setError(true));
  }, [registryId]);

  if (error) return <div className="py-40 text-center font-display text-2xl text-amber-200">Certificate not available</div>;
  if (!record) return <div className="py-40 text-center"><Loader2 className="w-6 h-6 animate-spin text-amber-300 mx-auto" /></div>;

  return (
    <div className="max-w-5xl mx-auto px-5 lg:px-10 py-24" data-testid="certificate-page">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <div className="hy-label">Certificate</div>
          <h1 className="font-display text-3xl sm:text-4xl text-white mt-4">{record.certificate_id || "Pending payment"}</h1>
        </div>
        <div className="flex gap-4">
          <a href={`${API}/certificate/${record.registry_id}/pdf`} target="_blank" rel="noreferrer"
            className="hy-btn px-7 py-3.5 text-xs uppercase flex items-center gap-2" data-testid="download-pdf-btn">
            <Download className="w-4 h-4" /> Download PDF
          </a>
          <button onClick={() => window.print()} className="hy-btn-ghost px-7 py-3.5 text-xs uppercase flex items-center gap-2" data-testid="print-btn">
            <Printer className="w-4 h-4" /> Print
          </button>
        </div>
      </div>

      <div className="mt-12">
        {record.payment_status === "PAID" ? (
          <Certificate record={record} />
        ) : (
          <div className="hy-card p-12 text-center" data-testid="certificate-locked">
            <p className="font-serif-accent italic text-lg text-slate-400">
              This certificate is issued once payment is confirmed.
            </p>
            <Link to={`/checkout/${record.registry_id}`} className="hy-btn inline-block px-8 py-4 text-xs uppercase mt-8">Complete payment</Link>
          </div>
        )}
      </div>
    </div>
  );
}
